import * as actions from '../actions/types'
import { getMessageForInvokeType } from '../libs/app'

const initialState = {
  options: {},
  alerts: [],
  openTerm: {},
  isInvoking: false,
  invokingMessage: "",
  newUser: false,
  updatingUser: false,
  optionsSet: false,
  openTermSet: false,
  applicationSet: false
};

function setOptions(appState, action) {
  const newState = invokeResponse(appState);
  return {
    ...newState,
    options: action.options,
    optionsSet: true
  };
}

function setOpenTerm(appState, action) {
  const newState = invokeResponse(appState);
  return {
    ...newState,
    openTerm: action.openTerm,
    openTermSet: true
  };
}

function addAlert(appState, action) {
  return {
    ...appState,
    alerts: [
      ...appState.alerts,
      action.alert
    ]
  }
}

function removeAlert(appState, action) {
  return {
    ...appState,
    alerts: appState.alerts.filter(alert => action.id !== alert.id)
  }
}

function invokeRequest(appState, action) {
  return {
    ...appState,
    isInvoking: true,
    invokingType: action.type,
    invokingMessage: getMessageForInvokeType(action.type)
  }
}

function invokeResponse(appState) {
  return {
    ...appState,
    isInvoking: false,
    invokingMessage: '',
    invokingType: ''
  }
}

function setNewUser(appState, action) {
  return {
    ...appState,
    newUser: action.newUser
  }
}

function setUser(appState, action) {
  return {
    ...appState,
    newUser: !action.user.complete && !action.user.updating,
    updatingUser: action.user.updating
  }
}

function setApplication(appState) {
  const newState = { ...appState, applicationSet: true };
  return invokeResponse(newState);
}

function applicationSet(appState) {
  return {
    ...appState,
    applicationSet: true
  }
}

// TODO: Add invoking handling to different APIs to handle overlap
export const appInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.ADD_ALERT:
      return addAlert(state, action);
    case actions.REMOVE_ALERT:
      return removeAlert(state, action);
    case actions.FETCH_USER_REQUEST:
    case actions.CREATE_USER_REQUEST:
    case actions.CREATE_APPLICATION_REQUEST:
    case actions.FETCH_APPLICATION_REQUEST:
    case actions.OPTIONS_REQUEST:
    case actions.OPEN_TERM_REQUEST:
    case actions.SUBMIT_APPLICATION_REQUEST:
      return invokeRequest(state, action);
    case actions.FETCH_USER_SUCCESS:
    case actions.FETCH_USER_FAILURE:
    case actions.USER_NOT_FOUND:
    case actions.CREATE_APPLICATION_SUCCESS:
    case actions.CREATE_APPLICATION_FAILURE:
    case actions.FETCH_APPLICATION_FAILURE:
    case actions.OPTIONS_FAILURE:
    case actions.OPEN_TERM_FAILURE:
    case actions.SUBMIT_APPLICATION_SUCCESS:
    case actions.SUBMIT_APPLICATION_FAILURE:
      return invokeResponse(state, action);
    case actions.OPTIONS_SUCCESS:
      return setOptions(state, action);
    case actions.OPEN_TERM_SUCCESS:
      return setOpenTerm(state, action);
    case actions.SET_NEW_USER:
      return setNewUser(state, action);
    case actions.SET_USER:
      return setUser(state, action);
    case actions.FETCH_APPLICATION_SUCCESS:
      return setApplication(state, action);
    case actions.APPLICATION_DOES_NOT_EXIST:
      return applicationSet(state, action);
    default: return state;
  }
};

export default appInfoReducer;